import React from 'react'
import shuangqianMedalImg from '../../images/medals/shuangqian22.png'


class Medal extends React.Component {
    onClickMedal (e) {
        e.stopPropagation()
        this.props.onClickMedal(e)
    }
    render() {
        return (
            <span 
                onClick={e => this.onClickMedal(e)} 
                style={this.props.wrapStyle}
                className='wk-shuangqian-medal wk-pointer-hand' 
            >
                {
                    this.props.type === 'tt_achieve' && (
                        <img 
                            src={shuangqianMedalImg} 
                            style={this.props.style || {}}
                        />
                    )
                }
            </span>
        )
    }
}


export default Medal


// WEBPACK FOOTER //
// ./src/components/medal/Medal.js